import { shallowEqual } from 'react-redux';
import { useSsSelector } from '~SpectateStore';
import {
    selectMarketName,
    selectMarketsIdsForEvent,
    selectMarketSelectionSchema,
    selectMarketIsTradable,
    selectIsMarketCashoutRestricted,
    selectEventHasMarkets,
} from '~SpectateStore/selectors/marketsSelectors';
import {
    selectUiMarketSlug,
    selectUiMarketName,
    selectLinesforUiMarket,
    selectGoalscorerMarketHeaders,
} from '~SpectateStore/selectors/uiMarketSelectors';

export const useMarketIdsForEvent = eventId => useSsSelector(state => selectMarketsIdsForEvent(state, eventId), shallowEqual);
export const useMarketName = id => useSsSelector(state => selectMarketName(state, id));
export const useMarketSelectionSchema = id => useSsSelector(state => selectMarketSelectionSchema(state, id));
export const useMarketIsTradable = (eventId, marketId) => useSsSelector(state => selectMarketIsTradable(state, eventId, marketId));
export const useUiMarketSlug = id => useSsSelector(state => selectUiMarketSlug(state, id));
export const useUiMarketName = id => useSsSelector(state => selectUiMarketName(state, id));
export const useUiMarketLines = id => useSsSelector(state => selectLinesforUiMarket(state, id));
export const useIsMarketCashoutRestricted = (eventId, marketId) => useSsSelector(state => selectIsMarketCashoutRestricted(state, eventId, marketId));
export const useGoalscorerMarketHeaders = id => useSsSelector(state => selectGoalscorerMarketHeaders(state, id));
export const useEventHasMarkets = eventId => useSsSelector(state => selectEventHasMarkets(state, eventId), shallowEqual);
